import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/@babel/runtime/helpers/esm/createClass";

// TODO: Remove these linting exceptions after implementation.

/* eslint-disable @typescript-eslint/no-unused-vars */

/* eslint-disable @typescript-eslint/no-empty-function */

/* eslint-disable @typescript-eslint/explicit-function-return-type */
var ConnectorEthereum =
/*#__PURE__*/
function () {
  function ConnectorEthereum(config) {
    _classCallCheck(this, ConnectorEthereum);

    this.name = 'ethereum';
    this.config = config;
    this.network = config.network;
  }

  _createClass(ConnectorEthereum, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(connection) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.connection = connection;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connect(_x) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                delete this.connection;

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "permissionsForOrg",
    value: function () {
      var _permissionsForOrg = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve) {
                  resolve([]);
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function permissionsForOrg() {
        return _permissionsForOrg.apply(this, arguments);
      }

      return permissionsForOrg;
    }()
  }, {
    key: "onPermissionsForOrg",
    value: function onPermissionsForOrg(organization, callback) {
      return {
        unsubscribe: function unsubscribe() {}
      };
    }
  }, {
    key: "appForOrg",
    value: function appForOrg(organization, filters) {
      return new Promise(function (resolve) {
        resolve();
      });
    }
  }, {
    key: "appsForOrg",
    value: function appsForOrg(organization, filters) {
      return new Promise(function (resolve) {
        resolve([]);
      });
    }
  }, {
    key: "onAppForOrg",
    value: function onAppForOrg(organization, filters, callback) {
      return {
        unsubscribe: function unsubscribe() {}
      };
    }
  }, {
    key: "onAppsForOrg",
    value: function onAppsForOrg(organization, filters, callback) {
      return {
        unsubscribe: function unsubscribe() {}
      };
    }
  }, {
    key: "repoForApp",
    value: function repoForApp(organization, appAddress) {
      return new Promise(function (resolve) {
        resolve();
      });
    }
  }, {
    key: "appByAddress",
    value: function appByAddress(organization, appAddress) {
      return new Promise(function (resolve) {
        resolve();
      });
    }
  }, {
    key: "rolesForAddress",
    value: function rolesForAddress(organization, appAddress) {
      return new Promise(function (resolve) {
        resolve([]);
      });
    }
  }]);

  return ConnectorEthereum;
}();

export default ConnectorEthereum;